import { Typography } from '@material-ui/core';
import { ExclamationOutlineIcon, iconVariants } from '@fountain/ripple/icon';
import React, { ReactNode, VFC } from 'react';

import { useStyles } from './styles';

export interface ValidationErrorProps {
  children: ReactNode;
  // Only the footer summary announces — one live region carrying the count,
  // not one per unanswered question.
  role?: 'alert';
}

// A blocked-submit validation error: red icon and text, no background. The
// InlineMessage banner stays reserved for request failures.
export const ValidationError: VFC<ValidationErrorProps> = ({
  children,
  role,
}) => {
  const classes = useStyles();
  return (
    <Typography
      variant="body2"
      component="span"
      role={role}
      className={classes.validationError}
    >
      <ExclamationOutlineIcon
        className={iconVariants({ size: 'sm' })}
        aria-hidden
      />
      {children}
    </Typography>
  );
};
